/*! @pentacode/ui v0.1.0 */
import { t as e } from "../decorateMetadata-BXz2gmG4.js";
import { t } from "../decorate-C_HUHFGG.js";
import "lit";
import { property as n } from "lit/decorators.js";
// src/elements/formElement.ts
var r = (r) => {
	class i extends r {
		connectedCallback() {
			super.connectedCallback();
		}
		disconnectedCallback() {
			super.disconnectedCallback();
		}
		static {
			this.formAssociated = !0;
		}
		get formValue() {
			return this.value;
		}
		updated(e) {
			e.has("value") && this.internals.setFormValue(this.formValue), super.updated(e);
		}
		constructor(...e) {
			super(...e), this.value = null, this.internals = this.attachInternals();
		}
	}
	return t([n(), e("design:type", Object)], i.prototype, "value", void 0), i;
};
export { r as FormElement };

//# sourceMappingURL=formElement.js.map